import { Axios } from "./request";

const API_URL = "filesapi/v1/attachments/";

export const FILE_MANAGEMENT_API = {
  Upload: (file) => {
    let formData = new FormData();
    formData.append("file", file);
    return Axios.post(`${API_URL}upload`, formData, {
      headers: { "content-type": "multipart/form-data" },
    });
  },
  Download: (key) => {
    return Axios.get(`${API_URL}download/${key}`, {
      responseType: "blob",
    });
  },
  GetSystemConfig: () => {
    return Axios.get(`${API_URL}GetSystemConfig`, {
      transformResponse: transformSystemConfigs,
    });
  },
};

const transformSystemConfigs = (response) => {
  let parsedResponse = JSON.parse(response);
  let data = parsedResponse.data;
  let maximumUploadSizeObj = data.find((item) => item.key === "MaximumUploadSize");
  let maximumUploadSize = maximumUploadSizeObj.value;
  let validUploadFormat = data.reduce(
    (acc, current) => (current.key === "validUploadFormat" ? [...acc, current.value] : acc),
    []
  );
  return { ...parsedResponse, data: { maximumUploadSize, validUploadFormat } };
};
